import { Level2, Level3, Level4 } from '../StyledOl';

const ConfidentialityAndDataProtection = () => (
  <li>
    CONFIDENTIALITY AND DATA PROTECTION
    <Level2>
      <li>
        As between the Parties, LINK Information shall be and remain the sole and exclusive property
        of LINK.
      </li>
      <li>
        LINK shall have full discretion in determining the scope, extent and type of information
        which it wishes to disclose to the Contractor for or in connection with this Purchase Order
        (which information will comprise the LINK Information).
      </li>
      <li>
        The Contractor shall upon the expiry or termination of this Purchase Order (howsoever
        occasioned) or upon the written request of LINK, within 14 days, return to LINK or destroy
        (as LINK may direct) at the Contractor&rsquo;s own cost and expense, all materials
        containing LINK Information and copies thereof in the Contractor&rsquo;s and/or its
        subcontractors&rsquo; custody, possession or control and shall certify to LINK that no
        copies thereof have been retained.
      </li>
      <li>
        In relation to LINK Information, the Contractor shall:
        <Level3>
          <li>
            comply with all LINK security policies, standards, requirements and specifications, as
            updated by LINK in writing from time to time, with respect to safeguarding LINK
            Information;
          </li>
          <li>
            provide appropriate equipment and software to implement security solutions in accordance
            with LINK&rsquo;s standards and requirements;
          </li>
          <li>
            segregate all LINK Information from that of any third party, including any other client
            of the Contractor;
          </li>
          <li>
            give access to LINK Information only to the subcontractors and Contractor personnel on a
            &lsquo;need to know&rsquo; basis and the procure that such subcontractors and Contractor
            personnel (1) are informed of the confidential nature of LINK Information; (2) hold and
            use LINK Information in confidence; and (iii) undertake to comply with the obligations
            relating to LINK Information under this Purchase Order;
          </li>
          <li>
            not modify, amend, alter, delete, publish or disclose LINK Information to any Third
            Party, nor allow any Third Party to process LINK Information on the Contractor&rsquo;s
            behalf unless LINK has given its prior written consent;
          </li>
          <li>
            establish and maintain safeguards against the:
            <Level4>
              <li>unauthorised, accidental or unlawful access, disclosure, use or processing;</li>
              <li>
                destruction, corruption, interference, loss, modification, amendment or alteration;
                or
              </li>
              <li>other misuse,</li>
            </Level4>
            of LINK Information in the custody, possession or control of Contractor or its
            subcontractor that are no less rigorous than the most rigorous practices of LINK and
            Contractor, for similar types of information;
          </li>
          <li>
            ensure that LINK Information provided to it in connection with this Purchase Order is
            stored or recorded accurately;
          </li>
          <li>
            as soon as the Contractor becomes aware of any breach or potential breach of security
            relating to or including LINK Information or any unauthorised collection, disclosure,
            use or loss of LINK Information (1) promptly and in no event later than 24 hours after
            it becoming aware of such breach or potential breach, notify LINK of the same in
            writing; and (2) comply with LINK&rsquo;s then-current data protection reporting
            processes in accordance with LINK&rsquo;s instruction at the relevant time including
            without limitation providing LINK with full details of, and investigate and assist LINK
            in investigating the same. LINK&rsquo;s data protection reporting processes at the time
            of this Purchase Order is set out as Annex A of these Terms and Conditions;
          </li>
          <li>
            co-operate with LINK in any investigation or litigation against third parties deemed
            necessary by LINK to protect the interests of LINK or LINK&rsquo;s rights in the LINK
            Information; and
          </li>
          <li>
            from time to time on request by LINK, the Contractor will do or procure the doing of all
            such acts and execute or procure the execution of all such documents as LINK may
            consider necessary or desirable for compliance with PDPA and any data protection
            legislation.
          </li>
        </Level3>
      </li>
      <li>
        Except with the prior written consent of LINK, the Contractor shall not disclose the
        Purchase Order or any purchases made in this Purchase Order or any provisions/terms thereof
        or any information or Personal Data issued or furnished by or on behalf of LINK in
        connection therewith to any person not employed by the Contractor.
      </li>
      <li>
        In addition to the foregoing, the Contractor shall not make use of any information or
        Personal Data obtained directly or indirectly from LINK or compiled or generated by the
        Contractor in the course of this Purchase Order which pertains to or is derived from such
        information, other than use for the purposes of this Purchase Order, without the prior
        written consent of LINK.
      </li>
      <li>
        The Contractor shall not publish or release, nor shall it allow the publication or release
        of, any news item, article, publication, advertisement, prepared speech or any other
        information or material pertaining to any part of the obligations to be performed under the
        Purchase Order in any media without the prior written consent of LINK.
      </li>
      <li>
        The Contractor shall not use the name, logo or trademarks of LINK, or any abbreviation
        thereof, without the prior written consent of LINK.
      </li>
      <li>
        To the extent that the Contractor has access to or receives Personal Data from LINK:
        <Level3>
          <li>
            The Contractor represents and warrants to LINK that it has at all times complied with
            the requirements of the Personal Data Protection Act of Singapore 2012 (&ldquo;
            <strong>PDPA</strong>&rdquo;) in respect of the Contractor&rsquo;s collection (if
            applicable), use, processing, disclosure (if applicable), protection, retention and
            other handling of such Personal Data, and the Contractor undertakes to continue to
            comply with the aforesaid requirements of the PDPA in respect of such Personal Data;
          </li>
          <li>
            The Contractor shall not transfer any such Personal Data outside Singapore without the
            written consent of LINK; and
          </li>
          <li>
            If any Singapore telephone number which forms part of the Personal Data is proposed to
            be used as the addressee of a voice call, fax or text message (including SMS/MMS, or
            through any data service) in the provision of Services, the Contractor represents and
            warrants to LINK that such Singapore telephone number shall be used for such purpose
            only if: (i) the message to be sent is not a "specified message" as defined in the PDPA;
            or (ii) the prior written consent of the relevant recipient has been obtained.
          </li>
        </Level3>
      </li>
      <li>
        To the extent that the Contractor discloses Personal Data to LINK, the Contractor undertakes
        to LINK that, by the time of such disclosure:
        <Level3>
          <li>
            the Contractor will have obtained all the necessary consents from the relevant
            individuals to whom the Personal Data relates, for the disclosure of their Personal Data
            to LINK for LINK&rsquo;s collection, use and/or disclosure for the purposes of this
            Purchase Order; and
          </li>
          <li>such consents have not been withdrawn.</li>
        </Level3>
      </li>
      <li>
        The Contractor shall permit LINK designees (subject to reasonable and appropriate
        confidentiality undertakings) access to its premises, records, and data protection
        processes, and to those of its subcontractors; to audit the Contractor&rsquo;s compliance
        with its obligations under this Clause 21, including allowing such access immediately in the
        event of any data protection breach. Each such audit shall be carried out at LINK&rsquo;s
        cost and expense unless any unreported data protection breach is uncovered in the course of
        such audit in which case the relevant audit will be at the Contractor&rsquo;s cost and
        expense.
      </li>
      <li>This Clause 21 shall survive the expiration or termination of this Purchase Order.</li>
    </Level2>
  </li>
);

export default ConfidentialityAndDataProtection;
